import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { SignaturePadComponent } from '@almothafar/angular-signature-pad';
import { Options } from 'signature_pad';
import { Location } from '@angular/common';

interface NgSignaturePadOptions extends Options {
    canvasHeight: number;
    canvasWidth: number;
}

@Component({
    selector: 'sign-pad',
    templateUrl: './sign-pad.component.html',
    styleUrls: ['./sign-pad.component.scss']
})
export class SignPadTestComponent implements OnInit {
    @Input() required: boolean = false;
    @Input() signatureString: string = '';
    @Input() disabled: boolean;
    @Input() label: string = 'Your Signature';
    @Output() signatureStringChange: EventEmitter<string> = new EventEmitter<string>();
    @Input('reviewMode') reviewMode: boolean;

    tempSignature: string = '';
    hideSignatureClearButton: boolean = false;
    
    @ViewChild('signature') signaturePad!: SignaturePadComponent;

    signaturePadOptions: NgSignaturePadOptions = {
        // passed through to szimek/signature_pad constructor
        //minWidth: 5,
        canvasWidth: 550,
        canvasHeight: 150,
        backgroundColor: 'rgb(255, 255, 255, 0)'
    };

    constructor(private location: Location) {
        // no-op
    }

    ngOnInit(): void {
        if (this.location.path().includes('/ecoe/view') || this.location.path().includes('/review/view') || this.location.path().includes('/papercoe/view'))
            this.hideSignatureClearButton = true;
        else if (this.reviewMode)
            this.hideSignatureClearButton = true;
        else
             this.hideSignatureClearButton = false;
    }

    ngAfterViewInit() {
        // this.signaturePad is now available
        this.signaturePad?.set('minWidth', 5); // set szimek/signature_pad options at runtime
        this.signaturePad?.clear(); // invoke functions from szimek/signature_pad API
    }

    drawComplete(event: MouseEvent | Touch) {
        // will be notified of szimek/signature_pad's onEnd event
        //console.log('Completed drawing', event);
        //console.log(this.signaturePad.toDataURL());

        this.tempSignature = this.signaturePad.toDataURL();
    }

    drawStart(event: MouseEvent | Touch) {
        // will be notified of szimek/signature_pad's onBegin event
        //console.log('Start drawing', event);
    }

    sign() {
        this.signatureString = this.tempSignature;
        this.signatureStringChange.emit(this.signatureString);
    }

    clear() {
        this.signaturePad.clear();
        this.tempSignature = '';
    }

    resign() {
        this.signatureString = '';
        this.tempSignature = '';

        this.signatureStringChange.emit(this.signatureString);
    }
}
